import api from './api';

export const einviteService = {
  async uploadVideoInvite(weddingId, organizationId, file) {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post(
      `/api/einvites/upload-video?wedding_id=${weddingId}&organization_id=${organizationId}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    return response.data; // { video_url }
  },

  async uploadImageInvite(weddingId, organizationId, file) {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post(
      `/api/einvites/upload-image?wedding_id=${weddingId}&organization_id=${organizationId}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    return response.data; // { image_url }
  },

  async publishInvite(weddingId, organizationId, templateId, inviteData) {
    const response = await api.post(
      `/api/einvites?wedding_id=${weddingId}&organization_id=${organizationId}`,
      {
        template_id: templateId,
        invite_data: inviteData
      }
    );
    return response.data;
  },

  async getPublishedInvite(weddingId, organizationId) {
    const response = await api.get(
      `/api/einvites/wedding/${weddingId}?organization_id=${organizationId}`
    );
    return response.data;
  },

  async getInviteByToken(shareToken) {
    const response = await api.get(`/api/einvites/share/${shareToken}`);
    return response.data;
  },

  async getAllPublishedInvites(organizationId) {
    const response = await api.get(
      `/api/einvites/organization/${organizationId}`
    );
    return response.data;
  },

  async shareInvite(weddingId, organizationId, guestIds, method, inviteId = null) {
    const response = await api.post(
      `/api/einvites/share?wedding_id=${weddingId}&organization_id=${organizationId}`,
      {
        guest_ids: guestIds,
        method: method, // 'email' or 'whatsapp'
        invite_id: inviteId // Optional: specific invite to share
      }
    );
    return response.data;
  }
};

